export function getOwnerPosition(position, lang) {
  const defaultLang = 'en';

  return position[lang] ?? position[defaultLang];
}
